document.addEventListener("DOMContentLoaded", function () {
  const inputBuscador = document.getElementById("input_buscador_pedido");
  const btnBuscador = document.getElementById("btn_buscador_pedido");
  inputBuscador.value = "QDMX_";
  input_buscador_pedido.maxLength = 10;
  function buscarPedido() {
    if (inputBuscador.value.length < 10) {
      Swal.fire({
        icon: "error",
        title: "Pedido incompleto",
        text: "Proporciona el codigo de 10 caracteres",
        backdrop: `rgba(220, 53, 69, 0.5)`,
        customClass: {
          popup: "swal",
        },
      });
      return;
    }
    Swal.fire({
      title: "Cargando...",
      html: "Consultando datos, por favor espere.",
      footer: '<p class="color-grisBajo no-margin">No cierre la página</p>',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      customClass: {
        popup: "swal",
      },
      backdrop: `rgba(245, 40, 145, 0.41)`,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    (async () => {
      try {
        const pedidoId = inputBuscador.value;
        const requestUrl = `${baseurl}/api/pedidos/existe_pedido_id?pedido_id=${pedidoId}`;

        const response = await fetch(requestUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
        Swal.close();

        if (data.success === "1") {
          window.location.href = `${baseurl}/mipedido?mipedido=${pedidoId}`;
        } else {
          Swal.fire({
            icon: "error",
            title: "Pedido no existe",
            text: data.message,
          });
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Error de conexión: ${error.message}`,
        });
      }
    })();
  }

  // Event listeners
  inputBuscador.addEventListener("keyup", function (event) {
    if (event.keyCode === 13) {
      buscarPedido();
    }
  });

  btnBuscador.addEventListener("click", buscarPedido);
});
